import * as Css from "./style";
import IconClose from '@zendeskgarden/svg-icons/src/16/x-stroke.svg?react';
import IconFile from '@zendeskgarden/svg-icons/src/16/file-document-stroke.svg?react';
import { FileDropzoneProps } from "./filedropzoneType";
import { useFileDropzone } from "./useFileDropzone";

export function FileDropzone(props : FileDropzoneProps) {
    const {inputRef, handleFiles, file, isRemoving, removeFile } = useFileDropzone(props)

    return (
        <Css.ContainerFileDropzone>
            <input
                ref={inputRef}
                type="file"
                accept=".xlsx,.csv,.txt"
                style={{ display: "none" }}
                onChange={(e) => handleFiles(e.target.files)}
            />

            {!file && (
                <Css.ContainerFiles
                    onClick={() => inputRef.current?.click()}
                    onDragOver={(e) => {
                        e.preventDefault();
                        // setIsDragging(true);
                    }}
                    // onDragLeave={() => setIsDragging(false)}
                    onDrop={(e) => {
                        e.preventDefault();
                        // setIsDragging(false);
                        handleFiles(e.dataTransfer.files);
                    }}
                >
                    <p>Arraste sua planilha aqui ou clique para selecionar um arquivo</p>
                </Css.ContainerFiles>
            )}

            {file && (
                <Css.ContainerWithFile className={isRemoving ? "fade-out" : ""}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", overflow: "hidden", textOverflow: "ellipsis", color: "#2F3941" }}>
                        <IconFile /> {file.name}
                    </div>

                    <button
                        onClick={removeFile}
                        style={{
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            fontSize: "16px",
                        }}
                        aria-label="Remover arquivo"
                    >
                        <IconClose />
                    </button>
                </Css.ContainerWithFile>
            )}
        </Css.ContainerFileDropzone>
    );
}
